/**
 * Controls above the Forecast grid: the All / Open PO only / Forecast only
 * strip, then the horizontal-scroll bar with the horizon summary.
 */
import { Button } from '../../../ui/button';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

interface ForecastGridControlsProps {
  /** Applied record-type filter: '' = All, '2' = Open PO, '1' = Forecast. */
  recordType: string;
  onRecordTypeChange: (value: string) => void;
  /** e.g. "Weeks 1-12 | Months 1-24 | Future". */
  horizonLabel: string;
  canScrollLeft: boolean;
  onScroll: (direction: 'left' | 'right') => void;
}

export function ForecastGridControls({
  recordType, onRecordTypeChange, horizonLabel, canScrollLeft, onScroll,
}: ForecastGridControlsProps) {
  return (
    <>
      {/* Quick filter strip — count summary intentionally removed: the
          "(N parts)" total in the title bar is the source of truth. */}
      <div className="flex items-center justify-end mb-3 p-3 rounded-md bg-slate-50 border">
        <div className="flex items-center gap-1">
          <Button size="sm" variant={recordType === '' ? 'default' : 'outline'} onClick={() => onRecordTypeChange('')}>
            All
          </Button>
          <Button
            size="sm"
            variant={recordType === '2' ? 'default' : 'outline'}
            onClick={() => onRecordTypeChange('2')}
            className={recordType === '2' ? 'bg-green-600 hover:bg-green-700' : ''}
          >
            Open PO only
          </Button>
          <Button
            size="sm"
            variant={recordType === '1' ? 'default' : 'outline'}
            onClick={() => onRecordTypeChange('1')}
            className={recordType === '1' ? 'bg-orange-500 hover:bg-orange-600' : ''}
          >
            Forecast only
          </Button>
        </div>
      </div>

      <div className="flex items-center justify-between mb-2">
        <Button variant="ghost" size="sm" onClick={() => onScroll('left')} disabled={!canScrollLeft}>
          <ChevronLeft className="h-4 w-4" />
          Scroll Left
        </Button>
        <div className="text-xs text-muted-foreground flex items-center gap-1">
          <Calendar className="h-3 w-3" />
          {horizonLabel}
        </div>
        <Button variant="ghost" size="sm" onClick={() => onScroll('right')}>
          Scroll Right
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </>
  );
}
